<template>
  <button
    type="button"
    class="btn btn-secondary btn-min-width"
    @click="downloadTableXLSX"
  >
    <i class="icon-download4"></i> <slot> Скачать в формате .xlsх</slot>
  </button>
</template>
<script>
export default {
  name: "DownloadTableXLSXButton",
  props: {
    fields: Array,
    items: Array,
    filename: String,
  },
  methods: {
    downloadTableXLSX() {
      let excel = this.$JExcel.new("Calibri 12 #000000");
      excel.set({ sheet: 0, value: this.filename });
      let hStyle = excel.addStyle({
        font: "Calibri 14 #000000 B",
        fill: "#E0E0E0",
        align: "C C W",
      });
      let sStyle = excel.addStyle({
        isstring: true,
      });
      let dStyle = excel.addStyle({
        isstring: false,
      });
      for (let i = 0; i < this.fields.length; i++) {
        const colHeader = this.fields[i].label;
        excel.set(0, i, 0, colHeader, hStyle);
        this.fields[i].colWidth = colHeader.length + 5;
      }

      let cr = 1;

      this.items.forEach((r) => {
        for (let i = 0; i < this.fields.length; i++) {
          const col = this.fields[i];
          let value = "";

          if (col.formatter) {
            value = col.formatter(r[col.key], col.key, r);
          } else {
            value = r[col.key] || "";
          }

          excel.set(0, i, cr, value, col.type == Number? dStyle : sStyle);

          if (value && String(value).length + 5 > col.colWidth)
            col.colWidth = String(value).length + 5;
        }
        cr++;
      });

      for (let i = 0; i < this.fields.length; i++) {
        excel.set(0, i, undefined, this.fields[i].colWidth);
      }
      excel.generate(`${this.filename}.xlsx`);
    },
  },
};
</script>